<template>
  <div class="user-themes pb-16">
    <div class="user-themes_row">
      <div class="user-themes_block mr-12 mb-4">
        <SettingsAnalyzerV2 />
      </div>
      <!-- <div class="user-themes_block mr-4 mb-4">
        <SettingsBetInPercent />

        <div class="theme-block-title mt-4">{{ $t('common.strategy') }}</div>
        <SettingsTotalHandFrequency />
        <SettingsHandValue />
        <SettingsLoadingTips />

        <SettingsEqbucketsStyle class="mt-4" />
      </div> -->
    </div>
    <div class="user-themes_block mr-4 mb-4">
      <div class="user-themes_block mr-4 mb-4"></div>
    </div>
  </div>
</template>

<script>
import SettingsAnalyzerV2 from '@/components/Dialogs/UserSettingsDialog/SettingsAnalyzerV2'

export default {
  name: 'UserGameSettings',

  components: {
    SettingsAnalyzerV2,
  },

  data() {
    return {}
  },
}
</script>
